import {
  ApolloClientOptions,
  ApolloLink,
  InMemoryCache,
} from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { APOLLO_NAMED_OPTIONS } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { StorageKeys } from 'src/app/configs/storage-keys-config';
import { AppConfigService } from '../services/config.service';

export function createApolloClients(
  httpLink: HttpLink
): Record<string, ApolloClientOptions<any>> {
  const apiUrl = AppConfigService.config.apiUrl;

  // get tokens
  const tokenKey = StorageKeys.accessToken;
  const token =
    localStorage.getItem(tokenKey) || sessionStorage.getItem(tokenKey);

  //set auth link
  const authLink = setContext(() => ({
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  }));

  return {
    // client 1
    [GraphqlClientType.ScheduledMessages]: {
      cache: new InMemoryCache(),
      link: ApolloLink.from([
        authLink,
        httpLink.create({
          uri: `${apiUrl}/${GraphqlClientType.ScheduledMessages}`,
        }),
      ]),
    },
    // client 2
    [GraphqlClientType.OutBoxMessages]: {
      cache: new InMemoryCache(),
      link: ApolloLink.from([
        authLink,
        httpLink.create({
          uri: `${apiUrl}/${GraphqlClientType.OutBoxMessages}`,
        }),
      ]),
    },
  };
}

export const appGraphqlProvider = [
  {
    provide: APOLLO_NAMED_OPTIONS,
    useFactory: createApolloClients,
    deps: [HttpLink],
  },
];

export enum GraphqlClientType {
  ScheduledMessages = 'ScheduledMessages',
  OutBoxMessages = 'OutBoxMessages',
}
